// UTM del enlace del anuncio (25/9/2026): se mandan con el alta para saber de qué anuncio viene
// cada cuenta (c_public_signups.utm → c_empresas.signup_utm). Sin UTM → undefined: el cuerpo
// del POST queda igual que antes.
export const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const MAX = 150;

export function readSignupUtm(search) {
  const params = new URLSearchParams(search || "");
  const out = {};
  for (const k of UTM_KEYS) {
    const v = (params.get(k) || "").trim().slice(0, MAX);
    if (v) out[k] = v;
  }
  return Object.keys(out).length ? out : undefined;
}
